module.exports = __webpack_public_path__ + "static/media/ic_display.2b699396.svg";